<div class="draggable-container"
     [ngClass]="contentClass"
     [attr.contenteditable]="isEditing ? 'true' : null"
     tabindex="0"
     (click)="onClick()"
     (dblclick)="onDoubleClick($event)"
     (blur)="onBlur()"
     cdkDrag
     [cdkDragDisabled]="isEditing"
     (cdkDragStarted)="onDragStarted()"
     (cdkDragEnded)="onDragEnded($event)">
  <ng-content></ng-content>
</div>